import React, { Component } from 'react'
import { Container, Col, Row } from 'react-bootstrap';
import { FormControl } from 'react-reactive-form';
import './IntroVideo.scss';
import ReactPlayer from 'react-player'
import {getCustomerDetails} from 'core/services/getCustomerDetailsService'
import { navigate } from '@reach/router';
import { getAmounts } from "core/services/amountService";
export interface IntroVideoProps {

}

export interface IntroVideoState {
  width?: string | number,
  height?: string | number,
  playState?: boolean,
  estVideo:any;
  
}


class IntroVideo extends React.Component<IntroVideoProps, IntroVideoState> {
  private _isMounted: boolean = false
  constructor(props: any) {
    super(props);
    this.state = {
      width: '100%',
      height: '100%',
      playState: false,
      estVideo:""
      
    };
  }
  async fetchData() {
    // debugger;
     //var CID = localStorage.getItem("CID")||"6981124";
     //var securetoken = localStorage.getItem("securetoken")||"2e780fee-5aef-44fe-90b6-02e276e532aa"
 
     const params = new URLSearchParams(window.location.search);
     const phone = params.get('phone') || "8442070741"; //
     var CID = params.get('customerid');
     var securetoken = params.get('customerToken');
     if(!CID)
     {
 CID=localStorage.getItem("CID")
     }
     else{
       localStorage.setItem("CID", CID)
     }
     if(!securetoken)
     {
       securetoken=localStorage.getItem("securetoken")
     }
     else{
       localStorage.setItem("securetoken", securetoken)
     }
     let response = await getCustomerDetails(CID||"",securetoken||"" )
     
     
     console.log(response)
     localStorage.setItem("customerDetails", JSON.stringify(response[0]));
     this.setState({estVideo:response[0].estimatorVideo})
  
     localStorage.setItem("EstimatorVideo", response[0].estimatorVideo);

/*      let response_amounts = await getAmounts(CID||"");
     localStorage.setItem("amounts", JSON.stringify(response_amounts.data.getEstFlowTotalAmountsAndDetails))
var signDone = "1" //response[0].customerSigFlag
var paymentDone = "1"// response[0].paymentFlag

if(signDone ==="1" && paymentDone==="1")
{
navigate("/move?question=booked")
}

if(signDone==="1" && paymentDone==="0"){
navigate("/move?question=deposit")

} */

 }

componentDidMount() {
  this._isMounted = true;
  this.fetchData();
}

componentWillUnmount() {
  this._isMounted = false;
}
  render() {
    const setPlay = () => {
      this.setState({ playState: !this.state.playState })
    }
    return (
      <div className='player-wrapper'>
        <ReactPlayer
          className='react-player'
          width={this.state.width}
          height={this.state.height}
          //url={localStorage.getItem("introVideo") || ""}
          url={this.state.estVideo}
          playing={this.state.playState}
          onStart={setPlay}
          controls
        />
      </div>
    )
  }

}

export default IntroVideo